import { Link } from 'react-router-dom';

export default function CompanyPage() {
  return (
    <div className="min-h-screen bg-white">
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-md mx-auto px-4 py-3 flex items-center gap-2">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-rose-500">
              <i className="ri-heart-pulse-fill text-white text-lg"></i>
            </div>
            <span className="font-bold text-lg text-gray-800" style={{ fontFamily: 'Pacifico, cursive' }}>
              LoveNavi
            </span>
          </Link>
        </div>
      </header>

      <main className="max-w-md mx-auto px-4 py-8">
        <h1 className="text-xl font-bold text-gray-800 mb-6">運営会社情報</h1>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
          <table className="w-full text-sm">
            <tbody>
              <tr className="border-b border-gray-100">
                <th className="text-left bg-rose-50/60 px-4 py-3.5 text-gray-700 font-bold text-xs w-[35%] align-top">運営者名</th>
                <td className="px-4 py-3.5 text-gray-600 text-xs leading-relaxed">LoveNavi運営事務局</td>
              </tr>
              <tr className="border-b border-gray-100">
                <th className="text-left bg-rose-50/60 px-4 py-3.5 text-gray-700 font-bold text-xs w-[35%] align-top">事業内容</th>
                <td className="px-4 py-3.5 text-gray-600 text-xs leading-relaxed">
                  マッチングアプリの比較・紹介メディアの運営<br />
                  インターネット広告事業<br />
                  Webメディアの企画・制作・運営
                </td>
              </tr>
              <tr>
                <th className="text-left bg-rose-50/60 px-4 py-3.5 text-gray-700 font-bold text-xs w-[35%] align-top">メール</th>
                <td className="px-4 py-3.5 text-gray-600 text-xs leading-relaxed">info@lovenavi.example.com</td>
              </tr>
            </tbody>
          </table>
        </div>
      </main>

      <footer className="bg-rose-50 py-6 px-4 mt-8">
        <div className="max-w-md mx-auto">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-gray-400 mb-3">
            <Link to="/privacy" className="hover:text-rose-500 transition-colors cursor-pointer">
              プライバシーポリシー
            </Link>
            <Link to="/terms" className="hover:text-rose-500 transition-colors cursor-pointer">
              利用規約
            </Link>
            <Link to="/company" className="hover:text-rose-500 transition-colors cursor-pointer">
              運営会社
            </Link>
          </div>
          <div className="text-center text-[10px] text-gray-400">
            <p>&copy; 2025 LoveNavi All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
